import React, { PropsWithChildren } from 'react';
import styles from './dictionary-components.module.scss';

export default function AkSmaller({ children }: PropsWithChildren<{}>) {
    return <span className={styles.wwiseAkSmaller}>{children}</span>;
}
